import React, { useState } from "react";
import { NavLink } from "react-router-dom";

// We define the logo path as a string variable. This prevents static bundling/resolution errors
// in compile-time builders while fully preserving your local relative asset file structure.

import logo from "../img/utpl.png";

function Header() {
  // Estado para controlar el despliegue del menú móvil
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <>
      {/* Contenedor principal con Tailwind CSS para obviar dependencias css externas */}
      <div className="bg-[#004270] shadow-md border-b border-white/10">
        <div className="max-w-6xl mx-auto py-3 px-4 flex justify-center md:justify-start">
          <NavLink to="/">
            <img
              src={logo}
              alt="Logo UTPL"
              className="h-8 sm:h-8 md:h-10 w-auto object-contain"
              onError={(e) => {
                e.target.src =
                  "https://utpl.edu.ec/sites/default/files/logo-utpl.png";
              }}
            />
          </NavLink>
        </div>
      </div>
    </>
  );
}

export default Header;
